import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayToList'
})
export class ArrayToListPipe implements PipeTransform {

  constructor() {}

  transform(value: Array<any>, separator: string = ', ', property: string | null = null): string {
    if (!Array.isArray(value)) {
      return (property !== null) ? value[property] : value;
    }
    if (property !== null) {
      value = value.map((item: any) => item[property]);
    }
    return value.join(separator);
  }

}
